export default __webpack_public_path__ + "static/Primus Schoolhouse-217ad4b1a8d03b210d99fbcd9618a275.png";